import { message } from "antd";
import { useTiMaxStore, getDeployArea } from "@ti/max";
import { firmwareQueryType } from "../services/configManager";
import packageInfo from "../../package.json";
import { baseUrl } from "../../config/common";

export const getuuid = () => {
  const tempUrl = URL.createObjectURL(new Blob());
  const uuId = tempUrl.toString();
  URL.revokeObjectURL(tempUrl);
  return uuId.substr(uuId.lastIndexOf("/") + 1);
};

/**
 * 生成 UUID
 */
export const generateUuid = (mode = "simple") => {
  if (mode === "simple") {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  if (mode === "hard") {
    let d = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16) % 16 | 0;
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }
};

// 更改挂载节点
export const getPopupContainer = () => document.querySelector(`.${packageInfo.name}`);

// 更改挂载节点
export const getContainer = () => document.querySelector(`.${packageInfo.name}`);

// 表单节点统一挂载
export const formItemAdapterProps = {
  getPopupContainer,
};

// 全局方法挂载点
export const contextHolderApi = {
  message,
  modal: null,
  notification: null,
};

/**
 * 秒转换时间
 */

export const transSecond = (value) => {
  const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
  const hour = Math.floor((value - day * 24 * 3600) / 3600);
  const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
  const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
  if (day > 0) {
    return `${day}天`;
  } else if (hour > 0) {
    return `${hour}小时`;
  } else if (minute > 0) {
    return `${minute}分钟`;
  }
  return `${second}秒`;
};

export function trimObjectValue(obj) {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === "string") {
      obj[key] = obj[key].trim();
    }
  });
  return obj;
}

export const getApiBaseUrl = () => {
  return baseUrl;
};

/* 下载附件 */
export const triggerDownloadFiles = async (
  api,
  params = null,
  filename = "导出",
  fileSuffix = "xls",
) => {
  const { locale } = useTiMaxStore.getState();
  const apiBaseUrl = getApiBaseUrl();
  const excelUrl = `${apiBaseUrl}${api}`;
  const querystring = params
    ? getQueryString({
        ...params,
        locale,
      })
    : "";

  const res = await fetch(`${excelUrl}${querystring ? "?" + querystring : ""}`, {
    method: "get",
    headers: {
      Authorization: sessionStorage.getItem("omc-token"),
      locale,
    },
  });
  const resText = await res.clone().text();
  if (resText.startsWith("{") && resText.endsWith("}")) {
    const result = await res.clone().json();
    message.error(result.text);
    return;
  }
  const data = await res.blob();
  const blobUrl = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.download = `${filename}.${fileSuffix}`;
  a.href = blobUrl;
  a.click();
};
const getQueryString = (obj) => {
  let string = "";
  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    if (value !== null && value !== undefined) {
      value = value.toString();
      string += `&${key}=${value}`;
    }
  });
  return string.slice(1);
};

export const download = (url) => {
  const ele = document.createElement("a");
  ele.download = encodeURI(url);
  ele.style.display = "none";
  ele.href = encodeURI(url);
  ele.target = "_blank"; // 针对 ie模式 的浏览器
  // 触发点击
  document.body.appendChild(ele);
  ele.click();
  // 然后移除
  document.body.removeChild(ele);
};

export const triggerDownloadOSSFiles = (src) => {
  const newSrc = src.split("?")[0];
  const a = document.createElement("a");
  a.href = newSrc;
  a.download = true;
  a.click();
};

export const downloadOSSFile = (fileUrl) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = fileUrl;
  downloadLink.click();
};

/**
 * 获取充电桩 设备类型、硬件类型枚举
 */
export const getTypeslist = async (func) => {
  let equipTypeList = [];
  let hardwareTypeList = [];

  const mapFun = (data = []) => {
    return data.map((e) => {
      return {
        value: e.type,
        text: e.name,
        label: e.name,
      };
    });
  };

  const res = await firmwareQueryType();
  if (res.code === "200") {
    equipTypeList = mapFun(res.data?.equipTypeList);
    hardwareTypeList = mapFun(res.data?.hardwareTypeList);
    func({
      equipTypeList,
      hardwareTypeList,
    });
  }
};

// 去除为""的字段
export function trimObjectValue1(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === "") {
      delete obj[key];
    }
  });
  return obj;
}

export const randomString = (len) => {
  const newLen = len || 32;
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const maxPos = chars.length;
  let pwd = "";
  for (let i = 0; i < newLen; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

export const getSuffix = (filename) => {
  const pos = filename.lastIndexOf(".");
  let suffix = "";
  if (pos !== -1) {
    suffix = filename.substring(pos);
  }
  return suffix;
};

export const simpleRender = (text) => {
  return (
    <div style={{
      wordWrap: "break-word",
      wordBreak: "break-word",
    }}
    >
      {text || "-"}
    </div>
  );
};

export const getDeployAreaIsChina = () => {
  return getDeployArea() === "cn";
};

/**
 * 判断是否有效值（不包括 0）
 */
export const isNone = (val) => !val && val !== 0;
